// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumCtaCell-cls1_DKL","cls2":"PremiumCtaCell-cls2_L38 PremiumCtaCell-cls1_DKL"};